import { useState, useRef, useCallback, useEffect } from 'react';
import { d as disableScroll, e as enableScroll } from './body-5de40423.js';

/**
Modal Hooks, like the file name says
Handles management of open/close state
Adding/removing CSS classes to body/html
*/

function useModalState(params = {}) {
  const {
    open: initialOpen,
    onToggle
  } = params;
  const [open, setOpen] = useState(initialOpen || false);
  const bodyElem = useRef();
  const htmlElem = useRef();
  const openModal = useCallback(() => {
    if (open) return;
    if (bodyElem && bodyElem.current) {
      disableScroll(bodyElem.current);
    }
    if (htmlElem && htmlElem.current) {
      disableScroll(htmlElem.current);
    }
    if (typeof onToggle === 'function') onToggle(true);
    setOpen(true);
  }, [open, setOpen, onToggle]);
  const closeModal = useCallback(() => {
    if (!open) return;
    if (bodyElem && bodyElem.current) {
      enableScroll(bodyElem.current);
    }
    if (htmlElem && htmlElem.current) {
      enableScroll(htmlElem.current);
    }
    if (typeof onToggle === 'function') onToggle(false);
    setOpen(false);
  }, [open, setOpen, onToggle]);
  useEffect(() => {
    bodyElem.current = document.body;
    htmlElem.current = document.documentElement;
    return closeModal;
  }, [closeModal]);
  return {
    open,
    openModal,
    closeModal
  };
}

export { useModalState as default };
